import { Flex } from '@radix-ui/themes';
import { Outlet } from 'react-router-dom';
import Navigation from '../Navigation';
import { Separator } from '../../ui/Separator';
import { MainSidebar } from '../Navigation/mainSidebar';


// export default function RootLayout() {
//   return (
//     <Flex direction="column" height="100%">
//       <Navigation />
//       <Separator />
//       <Outlet />
//     </Flex>
//   );
// }

export default function RootLayout() {
  return (
    <div className='h-screen w-full flex flex-row overflow-hidden bg-background'>
      <MainSidebar />
      <Outlet />
    </div>
  );
}